/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_DisclaimerInputs */

const en_fc_footer_disclaimer = /** @type {(inputs: Fc_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GetFilmCraft at getfilmcraft.org is an independent guide to the FilmCraft editor developed by ArtCraft. We provide download guidance, tutorials, browser access information and comparisons. We are not affiliated with or endorsed by ArtCraft or Adobe. FilmCraft and Adobe Premiere Pro belong to their respective owners.`)
};

/**
* | output |
* | --- |
* | "GetFilmCraft at getfilmcraft.org is an independent guide to the FilmCraft editor developed by ArtCraft. We provide download guidance, tutorials, browser acce..." |
*
* @param {Fc_Footer_DisclaimerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_disclaimer = /** @type {((inputs?: Fc_Footer_DisclaimerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_DisclaimerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_disclaimer(inputs)
});
export { fc_footer_disclaimer as "fc.footer.disclaimer" }